import { useNavigate } from "@tanstack/react-router";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { useCreateOutsource } from "../api/queries";
import { OutsourceForm } from "../ui/OutsourceForm";

export function OutsourceCreatePage() {
  const nav = useNavigate({ from: "/app/performance/outsources/create" });
  const createOutsource = useCreateOutsource();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "Outsource", to: "/app/performance/outsources" },
            { label: "ເພີ່ມໃໝ່" },
          ]}
        />
      </Header>

      <Main>
        <div className="mb-6">
          <h2 className="font-bold text-2xl tracking-tight">ເພີ່ມ Outsource</h2>
          <p className="text-muted-foreground">
            ບັນທຶກ master KOL / media / vendor — ໃຊ້ດຶງໃນ Event roster
          </p>
        </div>

        <div className="mx-auto max-w-3xl rounded-xl border bg-card px-4 sm:px-6">
          <OutsourceForm
            onSubmit={async (vals) => {
              try {
                const created = await createOutsource.mutateAsync({
                  categoryId: vals.categoryId,
                  payeeType: vals.payeeType,
                  displayName: vals.displayName,
                  contactName: vals.contactName ?? null,
                  phone: vals.phone?.trim() || null,
                  email: vals.email?.trim() || null,
                  bankName: vals.bankName?.trim() || null,
                  bankAccount: vals.bankAccount?.trim() || null,
                  bankAccountName: vals.bankAccountName?.trim() || null,
                  notes: vals.notes?.trim() || null,
                });
                nav({
                  to: "/app/performance/outsources/$id/edit",
                  params: { id: created.id },
                });
              } catch {}
            }}
            onCancel={() => nav({ to: "/app/performance/outsources" })}
            submitting={createOutsource.isPending}
          />
        </div>
      </Main>
    </>
  );
}
